import React, { useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import ConfirmRejectionDialog from 'views/pages/manage/unAssigned/studentFinanceApproval/paymodeApproval/ConfirmRejectionDialog';
import { getBenificiaryDetails, rejectionHandler } from '../utils';
import { EditHandler } from '../common';

const BmApprovalAction = ({ updateStatus, refundInfo,setLoader ,lastActionInfo}) => {
    const [updateStatusInfo, setUpdateStatusInfo] = useState(null)
    const { refundNumber, id, psid, orderType, approvalStatus,subOrderType } = refundInfo || {};
    const [editInfo, setEditInfo] = useState()
      const editBenificiaryHandler = async () => {
        setLoader(true)
        const res = await getBenificiaryDetails({ refundNumber })
        setLoader(false)
        setEditInfo({ row: { ...refundInfo, paymentModeAccountDetailId: res?.id } })
      }
    return (
        <Card style={{ width: "inherit", height: "auto", width: '400px', marginLeft: "24px" }}>
            <CardBody>
                <div className='d-flex flex-column' style={{ gap: '24px' }}>
                    <div className="dark-text label-color">Request actions</div>
                    <div className="regular-bold color-grey-60">Please take an action for this request. If you want some changes you can always send it back for correction.</div>
                    <div className='d-flex flex-column' style={{ gap: '8px' }}>
                        <AButton
                            variant="danger_filled"
                            size="xs"
                            className="no-ml-btn"
                            onClick={() => rejectionHandler({ orderType, id, setUpdateStatusInfo, approvalStatus,refundNumber,approvalAction:'REJECT', isRemarkMandatory:true, updatedOn: lastActionInfo?.updatedOn , updatedBy: lastActionInfo?.updatedBy, isUpdatedDetailRequired:true })}
                        >
                            Reject
                        </AButton>

                        <AButton
                            variant="primary_filled"
                            size="xs"
                            className="no-ml-btn"
                            onClick={() => updateStatus({ id, approvalAction: 'APPROVE', psid, refundNumber, approvalStatus: approvalStatus })}
                        >
                            Apporve
                        </AButton>

                        {orderType == "COMPLETION_REFUND" && <AButton
                            variant="outline"
                            textColor={"#000"}
                            className="no-ml-btn"
                            outlineVariantColor={"#CCC"}
                            size="xs"
                            onClick={() => { editBenificiaryHandler()}}
                        >
                            Edit
                        </AButton>
                        }
                        {orderType=='MULTI_TYPE_REFUND' && <AButton
                            variant="outline"
                            textColor={"#000"}
                            outlineVariantColor={"#CCC"}
                            size="xs"
                            onClick={() => {
                                const dialogInfo = {
                                    heading: "Send back for correction",
                                    subHeading: `Request No : ${refundNumber}`,
                                    proceedBtn: <button style={{ backgroundColor: '#00B0F5', width: 'fit-content', color: '#FFF', border: 'none' }}>Send back for correction</button>
                                }
                                rejectionHandler({ orderType, refundNumber, setUpdateStatusInfo, approvalStatus, approvalAction: 'RECHECK', dialogInfo,isRemarkMandatory:true })
                            }
                            }
                        >
                            Send for Correction
                        </AButton>
                        }
                    </div>
                </div>


                <ConfirmRejectionDialog
                    updateStatusInfo={updateStatusInfo}
                    setUpdateStatusInfo={setUpdateStatusInfo}
                    updateStatus={updateStatus}
                    dialogInfo={updateStatusInfo?.dialogInfo}
                    customStyle={{ maxWidth: '424px' }}
                />
                <EditHandler
                    setOpen={setEditInfo}
                    open={editInfo}
                    updateStatus={updateStatus}
                />
            </CardBody>
        </Card>
    )
}

export default BmApprovalAction